//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// 详情弹窗组件
import detailPop from "@/components/detailPop";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { detailPop },
  data() {
    //这里存放数据
    return {
      keyWord: "", //搜索关键词
      historyWords: [], //搜索历史
      hotKeywords: [],
      isShowResult: false,
      result: [], //搜索结果集

      // 详情弹窗
      isDetailPopShow: false, //名宿等详情弹窗
      details: {
        code: "", //详情的com_code 区分名宿20 优质景区1等等
        imgList: [],
        title: "",
        address: "",
        des: "",
        mobile: "",
        lat: "",
        lng: "",
        is_guide: false,
        id: ""
      } //详情弹窗组件的porps
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    inputFun() {
      console.log(this.commonFun.trim(this.keyWord));
      if (this.commonFun.trim(this.keyWord) == "") {
        this.isShowResult = false;
      }
    },
    search(word) {
      this.keyWord = word;
      this.getResult();
    },
    // 搜索获取结果
    getResult() {
      let that = this;
      console.log(that.keyWord);
      // 判断空字符串
      if (that.commonFun.trim(that.keyWord) == "") {
        console.log("空字符串");
        return;
      }
      let historyWords = JSON.parse(localStorage.getItem("historyWords"));
      console.log(historyWords);
      if (historyWords == null) {
        // 没有本地缓存
        historyWords = [that.keyWord];
        localStorage.setItem("historyWords", JSON.stringify([that.keyWord]));
      } else {
        // 有本地缓存
        // 先判断是否有历史相同缓存
        let isHave = false; //是否历史记录中存在该记录
        let idx; //记录中的下标
        for (var i in historyWords) {
          if (that.commonFun.trim(historyWords[i]) == that.keyWord) {
            isHave = true;
            idx = i;
            break;
          } else {
            isHave = false;
          }
        }
        if (isHave == true) {
          console.log(idx);
          let historyItem = historyWords[idx];
          historyWords.splice(idx, 1);
          historyWords.unshift(historyItem);
        } else {
          historyWords.unshift(that.keyWord);
        }
        localStorage.setItem("historyWords", JSON.stringify(historyWords));
      }
      this.historyWords = historyWords;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!Search.action",
        params: { keyword: that.keyWord },
        isShowLoading: true,
        success: function(data) {
          console.log(data.data);
          let result = data.data.data.searchs;
          for (let i in result) {
            switch (parseInt(result[i].type)) {
              case 1:
                result[i].typeName = "景区";
                break;
              case 2:
                result[i].typeName = "风情小镇";
                break;
              case 3:
                result[i].typeName = "乡村民宿";
                break;
              case 7:
                result[i].typeName = "重要景区村";
                break;
              case 8:
                result[i].typeName = "文化场馆";
                break;
            }
          }
          that.result = result;
          that.isShowResult = true;
        }
      });
    },
    // 获取热门搜索
    getHot() {
      let that = this;
      that.get({
        url: that.GLOBAL.BASE_URL + "/api/v1/index!GetKeyWords.action",
        isShowLoading: false,
        success: function(data) {
          console.log(data.data);

          that.hotKeywords = data.data.data.keyWords;
        }
      });
    },
    // 搜索结果点击
    resultFun(type, id, isGuide) {
      let that = this;
      console.log("type===" + type + "  id===" + id);

      if (type == 3) {
        // 名宿 跳详情弹窗
        that.get({
          url: that.GLOBAL.BASE_URL + "/api/v1/index!getHotelDetail.action",
          params: {
            id: id //景区id
          },
          isShowLoading: false,
          success: function(data) {
            console.log(data.data);
            let details = {};
            details.is_guide = false;
            details.id = id;
            details.imgList = data.data.data.imgs;
            details.title = data.data.data.homeStays.homestay_name;
            details.address = data.data.data.homeStays.address;
            details.des = data.data.data.homeStays.characters;
            details.mobile = data.data.data.homeStays.mobile;
            details.lat = data.data.data.homeStays.latitude;
            details.lng = data.data.data.homeStays.longitude;

            that.details = details;
          }
        });
        that.isDetailPopShow = true;
      } else {
        // 除民宿外的所有类别
        that.get({
          url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",
          params: { hid: id },
          isShowLoading: false,
          success: function(data) {
            console.log(data.data.data);
            let details = {};
            details.is_guide = isGuide;
            details.id = data.data.data.hotspot.id;
            details.imgList = [];
            for (let i in data.data.data.imgList) {
              details.imgList.push(
                that.GLOBAL.DOMAIN_URL + data.data.data.imgList[i].midImg
              );
            }
            // details.imgList = data.data.data.imgs;
            details.title = data.data.data.hotspot.name;
            details.address = data.data.data.hotspot.address;
            details.des = data.data.data.hotspot.description;
            details.mobile = "";
            details.lat = data.data.data.hotspot.latitudeGCJ + "";
            details.lng = data.data.data.hotspot.longitudeGCJ + "";
            if (data.data.data.hotspot.audio != null) {
              details.audio =
                that.GLOBAL.DOMAIN_URL +
                data.data.data.hotspot.audio.split(".")[0] +
                ".mp3";
            }

            that.details = details;
          }
        });
        that.isDetailPopShow = true;
        // if (isGuide) {
        //   // 有导览
        //   this.$router.push({
        //     path: "/map",
        //     name: "map",
        //     query: { hid: id }
        //   });
        // } else {
        // }
      }
    },
    // 监听detail组件是否展示组件的事件
    changeDetailPop(val) {
      this.isDetailPopShow = val;
      this.details = {
        code: "", //详情的com_code 区分名宿20 优质景区1等等
        imgList: [],
        title: "",
        address: "",
        des: "",
        mobile: "",
        lat: "",
        lng: "",
        is_guide: false,
        id: ""
      }; //清空详情组件的details props
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    document.title = "搜索";
    this.getHot();
    this.historyWords = JSON.parse(localStorage.getItem("historyWords"));
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/pages/search.vue